export type RuntimeEnv = {
  apiBaseUrl?: string;
  apiFeedUrl?: string;
  apiWalletUrl?: string;
  apiCrmUrl?: string;
  apiCasinoUrl?: string;
  keycloakUrl?: string;
  keycloakClientId?: string;
  keycloakRealm?: string;
  keycloakBoRealm?: string;
  wsPath: string;
  sanityProjectId?: string;
  sanityDataset?: string;
  growthbookApiHost: string;
  growthbookClientKey: string;
  minioUrl?: string;
  muiXLicenseKey?: string;
  openReplayIngestPoint?: string;
  openReplayProjectKey?: string;
  sentryDsn?: string;
  turnstileSiteKey?: string;
  environment: string;
  version?: string;
};

type RuntimeEnvSource = Pick<
  ImportMetaEnv,
  | 'VITE_API_BASE_URL'
  | 'VITE_API_FEED_URL'
  | 'VITE_API_WALLET_URL'
  | 'VITE_API_CRM_URL'
  | 'VITE_API_CASINO_URL'
  | 'VITE_KEYCLOAK_URL'
  | 'VITE_KEYCLOAK_CLIENT_ID'
  | 'VITE_KEYCLOAK_REALM'
  | 'VITE_KEYCLOAK_BO_REALM'
  | 'VITE_WS_PATH'
  | 'VITE_SANITY_PROJECT_ID'
  | 'VITE_SANITY_DATASET'
  | 'VITE_GROWTHBOOK_API_HOST'
  | 'VITE_GROWTHBOOK_CLIENT_KEY'
  | 'VITE_MINIO_URL'
  | 'VITE_MUI_X_LICENSE_KEY'
  | 'VITE_OPENREPLAY_INGEST_POINT'
  | 'VITE_OPENREPLAY_PROJECT_KEY'
  | 'VITE_SENTRY_DSN'
  | 'VITE_TURNSTILE_SITE_KEY'
  | 'VITE_ENV'
  | 'VITE_VERSION'
>;

export const createRuntimeEnv = (env: RuntimeEnvSource): RuntimeEnv => ({
  apiBaseUrl: env.VITE_API_BASE_URL,
  apiFeedUrl: env.VITE_API_FEED_URL,
  apiWalletUrl: env.VITE_API_WALLET_URL,
  apiCrmUrl: env.VITE_API_CRM_URL,
  apiCasinoUrl: env.VITE_API_CASINO_URL,
  keycloakUrl: env.VITE_KEYCLOAK_URL,
  keycloakClientId: env.VITE_KEYCLOAK_CLIENT_ID,
  keycloakRealm: env.VITE_KEYCLOAK_REALM,
  keycloakBoRealm: env.VITE_KEYCLOAK_BO_REALM,
  wsPath: env.VITE_WS_PATH ?? '',
  sanityProjectId: env.VITE_SANITY_PROJECT_ID,
  sanityDataset: env.VITE_SANITY_DATASET,
  growthbookApiHost: env.VITE_GROWTHBOOK_API_HOST ?? '',
  growthbookClientKey: env.VITE_GROWTHBOOK_CLIENT_KEY ?? '',
  minioUrl: env.VITE_MINIO_URL,
  muiXLicenseKey: env.VITE_MUI_X_LICENSE_KEY,
  openReplayIngestPoint: env.VITE_OPENREPLAY_INGEST_POINT,
  openReplayProjectKey: env.VITE_OPENREPLAY_PROJECT_KEY,
  sentryDsn: env.VITE_SENTRY_DSN,
  turnstileSiteKey: env.VITE_TURNSTILE_SITE_KEY?.trim() || undefined,
  environment: env.VITE_ENV ?? 'development',
  version: env.VITE_VERSION,
});

export const runtimeEnv = createRuntimeEnv(import.meta.env);
